// @flow
import {
  SET_PRICE_SHEET,
  UPDATE_QUOTE_LIST,
  GET_QUOTE_COMPANY_LIST,
  GET_PRODUCT_SHEET,
  ADMIN_UPDATE_PRODUCT_TIER,
  GET_QUOTE_LIST,
  GET_QUOTE_LICENCES
} from "../../global/actions/actionNames";

const initialState = {
  priceSheet: undefined,
  quotes: null,
  companies: null,
  productSheet: null,
  licences: null
};

const quoteReducers = (state: * = initialState, actions: *): * => {
  switch (actions.type) {
    case SET_PRICE_SHEET:
      if (actions.data !== null) {
        return {
          ...state,
          priceSheet: { ...actions.data }
        };
      }
      return state;

    case GET_QUOTE_LIST:
      if (actions.quotes !== null) {
        return {
          ...state,
          quotes: [...actions.quotes]
        };
      }

    case UPDATE_QUOTE_LIST:
      let quotes = state.quotes === null ? [] : [...state.quotes];
      if (actions.quote !== null && actions.quote.id !== null) {
        if (quotes.length > 0) {
          let index = quotes.findIndex(x => x.id === actions.quote.id);
          if (index > -1) {
            quotes[index] = actions.quote;
          } else {
            quotes.push(actions.quote);
          }
        } else {
          quotes.push(actions.quote);
        }
      }
      return {
        ...state,
        quotes: quotes
      };

    case GET_QUOTE_COMPANY_LIST:
      if (actions.companies !== null) {
        return {
          ...state,
          companies: [...actions.companies]
        };
      }
      return state;

    case GET_PRODUCT_SHEET:
      if (actions.productSheet !== null) {
        return {
          ...state,
          productSheet: { ...actions.productSheet }
        };
      }

    case ADMIN_UPDATE_PRODUCT_TIER:
      if (actions.tier !== null) {
        let priceSheet = { ...state.priceSheet };
        let tiers = priceSheet.tiers ? [...priceSheet.tiers] : [];
        let index = actions.tier && tiers.findIndex(x => x.id === actions.tier.id);
        if (index > -1) {
          tiers[index] = { ...actions.tier };
        } else {
          tiers.push({ ...actions.tier });
        }

        priceSheet.tiers = [...tiers];
        return {
          ...state,
          priceSheet: priceSheet
        };
      }
      return state;

    case GET_QUOTE_LICENCES:
      if (actions.licences !== null) {
        return {
          ...state,
          licences: [...actions.licences]
        };
      }
      return state;

    default:
      return state;
  }
};
export default quoteReducers;
